import { animateAproposImage } from "./gsap/animateAproposImage";
import { startLoopingItems } from "./gsap/loopRealisation";
import { animateAnchor } from "./gsap/anchorAnimation";
import "./wpform/addStyleCustom";
import "./responsive/displayMenu";
import "./responsive/hoverEffectToSingleProduct";
import "./global/smoothScrollAnchors";


//Gsap img a propos
document.addEventListener("DOMContentLoaded", () => {
  animateAproposImage();
  startLoopingItems();
  animateAnchor();
});



